import _ from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import Loader from '../../../../../../../common/widgets/Loader';
import { BenefitsContext } from '../../../../../contexts/BenefitsContext';
import { ProductListModel } from '../../../../../models/Product';
import { resources } from '../../../../../resources/resources';

interface ICategoryFilter {
  filteredProducts?: ProductListModel[];
  selectedCategoryIds: Set<number>;
  handleChange: (categoriesIds: Set<number>) => void;
}

const CategoryFilter = (props: ICategoryFilter) => {
  const { t: translate } = useTranslation();
  const { benefitRoots } = useContext(BenefitsContext);
  const { filteredProducts, selectedCategoryIds, handleChange } = props;

  const [categoryIds, setCategoryIds] =
    useState<Set<number>>(selectedCategoryIds);

  const getProductsCountForCategory = (categoryId: number): number => {
    let count = 0;

    filteredProducts?.forEach(p => categoryId === p.path[0] && count++);

    return count;
  };

  const categories = _.map(_.compact(_.values(benefitRoots)), category => {
    return {
      id: category.id,
      name: category.name,
      count: getProductsCountForCategory(category.id),
    };
  });

  const selectCategory = (id: number) => {
    setCategoryIds(prevCategories => new Set(prevCategories).add(id));
  };

  const deselectCategory = (id: number) => {
    setCategoryIds(prevCategories => {
      const updatedCategories = new Set(prevCategories);
      updatedCategories.delete(id);
      return updatedCategories;
    });
  };

  useEffect(() => {
    handleChange(categoryIds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryIds.size]);

  return (
    <Loader
      loading={
        !benefitRoots.benefitClubCategoryRoot?.name &&
        !benefitRoots.flexibleBenefitsCategoryRoot?.name &&
        !benefitRoots.discountVouchersCategoryRoot?.name
      }
      loader={<Skeleton />}
    >
      <div className="action-panel">
        <div className="action-panel-title">
          <span>{translate(resources.filters.chooseCategory)}</span>
        </div>
        <div className="action-panel-content secondary-nav">
          <ul>
            {categories.map(ctgry => {
              if (ctgry.id) {
                return (
                  <li
                    key={`${ctgry.id}_${ctgry.name}`}
                    className={
                      categoryIds.has(ctgry.id) ? 'nav-item active' : 'nav-item'
                    }
                  >
                    <a
                      onClick={() =>
                        !categoryIds.has(ctgry.id)
                          ? selectCategory(ctgry.id)
                          : deselectCategory(ctgry.id)
                      }
                    >
                      {ctgry.name}
                    </a>
                    <span>{`(${ctgry.count})`}</span>
                  </li>
                );
              }
            })}
          </ul>
        </div>
      </div>
    </Loader>
  );
};

export default CategoryFilter;
